export type DeviceStatus = {
  type: string;
  status: string;
};

export const TuyaDeviceStatus = {
  State: "state",
  Battery: "batteryRatio",
} as const;
